import ItnAPI from './_integrationApi.js';
import commonFn from '@/commons/commonFunction';
import httpClient from '@/apis/base/httpclient';

class IntegrationBusinessInformationApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'BusinessInformations';

  /**
   * Tìm kiếm thông tin doanh nghiệp từ tổng cục thuế
   * @param {*} taxCode
   * @returns
   */
  async getBusinessInformationLookUp(taxCode, isGetAll) {
    const url = `${this.getAPIUrl()}/BusinessInformationLookUp/${taxCode}/${isGetAll}`;
    const request = {url};
    return await this.getAsync(request);
  }
  async getDataCustomer(param){
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetDataCustomer',
      data: param,
    };

    return await httpClient.postAsync(request);
  }
}
export default new IntegrationBusinessInformationApi();
